import Image from "next/image";

import Photo from "@public/assets/documentary/jordan-typing.jpg";

import { PageTitleAndHeroText } from "../platform/PageTitleAndHeroText";

const BlogHero = () => {
  return (
    <>
      <div className="container-xl">
        <div className="my-32 flex flex-col gap-x-48 gap-y-48 sm:mt-[88px] sm:mb-[104px] lg:mx-120 lg:flex-row lg:items-end lg:justify-between ">
          <div className="max-w-[640px]  ">
            <PageTitleAndHeroText
              title="Blog"
              text="AI research, ideas and product updates."
            />
          </div>
        </div>
      </div>

      {/* Section dropped as image isn't right and not sure what copy is actually useful here. */}
      {/* <div className="dark bg-black pb-80">
        <div className="container-xl mt-80 text-white ">
          <div className="-container-xl relative flex h-[600px] flex-col gap-y-40 overflow-y-hidden md:ml-0  md:h-480  md:flex-row md:items-end lg:h-[640px]">
            <div className="relative h-full grow">
              <Image
                priority
                src={Photo}
                alt="Working"
                className="brightness contrast-125 grayscale"
                layout="fill"
                objectFit="cover"
              />
            </div>
            <div className="min-w-320 flex max-w-[400px] flex-col gap-24 px-40">
              <h3 className="font-display text-24-28 font-bold md:text-32-36">
                We&apos;re on the cutting edge of AI research
              </h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tortor
                amet nunc lorem orci tortor netus semper gravida. Habitant
                cursus cursus massa lobortis aliquet eros odio non. Eget
                pellentesque et et tempor pulvinar.
              </p>
            </div>
          </div>
          <div className="background h-full w-full"></div>
        </div>
      </div> */}
    </>
  );
};

export default BlogHero;
